import basicClassCreator from '../utils/basicClassCreator';

export default basicClassCreator('Spacer', 'mdl-layout-spacer');



/** WEBPACK FOOTER **
 ** ./src/Layout/Spacer.js
 **/